
import { createAction } from 'redux-actions'

export const SHOW_CHANGE_WORKSPACE_PLAN_CONFIRM = 'SHOW_CHANGE_WORKSPACE_PLAN_CONFIRM'
export const HIDE_CHANGE_WORKSPACE_PLAN_CONFIRM = 'HIDE_CHANGE_WORKSPACE_PLAN_CONFIRM'
export const SHOW_DELETE_WORKSPACE_CONFIRM = 'SHOW_DELETE_WORKSPACE_CONFIRM'
export const HIDE_DELETE_WORKSPACE_CONFIRM = 'HIDE_DELETE_WORKSPACE_CONFIRM'
export const CHANGE_WORKSPACE_PLAN_MIGRATION_STEP = 'CHANGE_WORKSPACE_PLAN_MIGRATION_STEP'
export const CLEAR_WORKSPACE_PLAN_MIGRATION = 'CLEAR_WORKSPACE_PLAN_MIGRATION'

export const showChangeWorkspacePlanConfirm = createAction(SHOW_CHANGE_WORKSPACE_PLAN_CONFIRM)
export const hideChangeWorkspacePlanConfirm = createAction(HIDE_CHANGE_WORKSPACE_PLAN_CONFIRM)
export const showDeleteWorkspaceConfirm = createAction(SHOW_DELETE_WORKSPACE_CONFIRM)
export const hideDeleteWorkspaceConfirm = createAction(HIDE_DELETE_WORKSPACE_CONFIRM)
export const changeWorkspacePlanMigrationStep = createAction(CHANGE_WORKSPACE_PLAN_MIGRATION_STEP)
export const clearWorkspacePlanMigration = createAction(CLEAR_WORKSPACE_PLAN_MIGRATION)



// WEBPACK FOOTER //
// ./actions/workspace-settings.js